const mutations = {
  userLoggedIn(state, payload) {
    state.isUserLoggedIn = true
    state.userAuthInfo = { 
      name: payload.response.name,
      token: payload.response.token,
      message: payload.response.message,
      email: payload.response.email,
      role: payload.response.role,
      emailVerified : payload.response.email_verified,
      profileVerified : payload.response.profile_verified
    }
    if (payload.rememberMe) {
      state.expiry = null
    } else {
      let date = new Date()
      date.setDate(date.getDate() + 1)
      state.expiry = date
    }
  },
  userLoggedInFromfreelancerVuex(state, payload) {
    state.isUserLoggedIn = true
    state.userAuthInfo = { 
      name: payload.response.userAuthInfo.name,
      token: payload.response.userAuthInfo.token,
      message: payload.response.userAuthInfo.message,
      email: payload.response.userAuthInfo.email,
      role: payload.response.userAuthInfo.role,
      emailVerified : payload.response.userAuthInfo.emailVerified,
      profileVerified : payload.response.userAuthInfo.profileVerified
    }
    
    if (payload.response.rememberMe) {
      state.expiry = null
    } else {
      let date = new Date()
      date.setDate(date.getDate() + 1)
      state.expiry = date
    }
  },
  userUpdateCookies(state, payload) {
    let existing_username = state.userAuthInfo.name;
    let updated_username = payload.first_name+' '+payload.last_name;
    if(existing_username != updated_username) {
      state.userAuthInfo.name = updated_username
    }
  },
  userLoggedOut(state) {
    state.isUserLoggedIn = false
    state.userAuthInfo = {}
    state.expiry = null
    
    if (window.localStorage && window.localStorage.freelancerVuex) {
      const vuexData = JSON.parse(window.localStorage.freelancerVuex)
      if (vuexData && vuexData.auth.isUserLoggedIn) {
        vuexData.auth.isUserLoggedIn = false
        vuexData.auth.isEmailVerified = false
        vuexData.auth.userAuthInfo = {}
        window.localStorage.setItem("freelancerVuex", JSON.stringify(vuexData))
      }
    }
  },
  openAuthModal(state, payload) {
    state.isAuthModalOpen = payload
  },
  setAuthTabModal(state, payload) {
    state.authModalTab = payload  
  },
  openLoginModal(state, payload) {
    state.isLoginModalOpen = payload
  },
  setUserName(state, payload) {
    state.userAuthInfo.name = payload
    // const vuexData = JSON.parse(window.localStorage.freelancerVuex)
    // vuexData.auth.userAuthInfo = state.userAuthInfo;
    // window.localStorage.setItem("freelancerVuex", JSON.stringify(vuexData))
  },
  openAlertModal(state, payload) {
    state.isAlertModalOpen = payload
  },  
  openLoginSelectionModal(state, payload) {
    state.isLoginSelectionModalOpen = payload
  },
  openSignupSelectionModal(state, payload) {
    state.isSignupSelectionModalOpen = payload    
  },
  LoginSelectionMode(state, payload) {
    state.LoginSelectionMode = payload
  },
  openForgetPasswordModal(state, payload) {
    state.isForgetPasswordModalOpen = payload
  }
}

export default mutations